"use strict";
/**
 * Waste Code Dictionary Sheet Generator
 *
 * Generates Excel sheets with waste code data (codes, descriptions, dangerous flag)
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatWasteCodeData = formatWasteCodeData;
exports.formatWasteCodeSheet = formatWasteCodeSheet;
var headers_1 = require("../headers");
var common_1 = require("../common");
var customHeaders = headers_1.WASTE_CODE_HEADERS;
var headerName = "KODY ODPADÓW";
/**
 * Formats waste code data into matrix for Excel
 * @param data - Array of waste code items
 * @returns Matrix ready for Excel insertion
 */
function formatWasteCodeData(data) {
    if (!data || data.length === 0) {
        throw new Error("Brak danych Katalogu Odpadów.");
    }
    var fieldKeys = [
        "code",
        "description",
        "isDangerous",
        "deleted"
    ];
    var rows = data.map(function (item) {
        return fieldKeys.map(function (key) {
            var value = item[key];
            if (value === null || value === undefined)
                return "";
            if (typeof value === "object")
                return JSON.stringify(value);
            // Specjalna obsługa dla pola "deleted"
            if (key === "deleted") {
                return value === true ? "Tak" : "";
            }
            // Specjalna obsługa dla pola "isDangerous"
            if (key === "isDangerous") {
                return value === true ? "Tak" : "Nie";
            }
            return value;
        });
    });
    return __spreadArray([customHeaders], rows, true);
}
/**
 * Generates and formats waste code dictionary sheet
 * @param sheetName - Name of the Excel sheet
 * @param data - Array of waste code items
 * @param isTrial - Whether this is trial version (limits to 5 records)
 * @param config - Configuration with ApplicationInsights instance
 */
function formatWasteCodeSheet(sheetName, data, isTrial, config) {
    return __awaiter(this, void 0, void 0, function () {
        var matrix_1, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    matrix_1 = formatWasteCodeData(data);
                    return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                            var sheet, range, headerRange, headersRange, dataRowsCount, i, rowIndex, textFormatColumns, currentYear, currentdate, formattedDate;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        sheet = context.workbook.worksheets.getItem(sheetName);
                                        range = sheet.getRangeByIndexes(1, 0, matrix_1.length, matrix_1[0].length);
                                        // Wysokości pierwszych 2 wierszy
                                        sheet.getRange("1:1").format.rowHeight = 20;
                                        sheet.getRange("2:2").format.rowHeight = 20;
                                        // Formatowanie kolumn
                                        sheet.getRange("A:A").format.columnWidth = 130;
                                        sheet.getRange("B:B").format.columnWidth = 700;
                                        sheet.getRange("B:B").format.wrapText = true;
                                        sheet.getRange("C:C").format.columnWidth = 140;
                                        sheet.getRange("D:D").format.columnWidth = 100;
                                        headerRange = sheet.getRange("A1:D1");
                                        headerRange.format.fill.color = "#688BBB";
                                        headerRange.format.font.color = "#FFFFFF";
                                        headerRange.format.font.bold = true;
                                        headerRange.format.font.size = 12;
                                        headerRange.format.verticalAlignment = "Center";
                                        headerRange.values = [[headerName, "", "", ""]];
                                        return [4 /*yield*/, context.sync()];
                                    case 1:
                                        _a.sent();
                                        headersRange = sheet.getRange("A2:D2");
                                        headersRange.format.fill.color = "#404040";
                                        headersRange.format.font.color = "#FFFFFF";
                                        headersRange.format.font.bold = true;
                                        headersRange.format.font.size = 16;
                                        headersRange.format.verticalAlignment = "Center";
                                        headersRange.format.horizontalAlignment = "Center";
                                        return [4 /*yield*/, context.sync()];
                                    case 2:
                                        _a.sent();
                                        dataRowsCount = matrix_1.length - 1;
                                        for (i = 0; i < dataRowsCount; i++) {
                                            rowIndex = i + 2;
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.rowHeight = 30;
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.fill.color = "#F7F7F7";
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.horizontalAlignment = "Center";
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.verticalAlignment = "Center";
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.font.size = 12;
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.borders.getItemAt(0).color = "#E9E9E9";
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.borders.getItemAt(0).weight = Excel.BorderWeight.thin;
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.borders.getItemAt(4).color = "#E9E9E9";
                                            sheet.getRange("A".concat(rowIndex + 1, ":D").concat(rowIndex + 1)).format.borders.getItemAt(4).weight = Excel.BorderWeight.thin;
                                        }
                                        // Format tekstowy dla kolumny A (kody odpadów)
                                        sheet.getRange("A3:A" + (2 + matrix_1.length)).format.horizontalAlignment = "Center";
                                        textFormatColumns = ["A"];
                                        textFormatColumns.forEach(function (column) {
                                            var columnRange = sheet.getRange("".concat(column, "3:").concat(column) + (2 + matrix_1.length));
                                            var formatArray = Array(matrix_1.length).fill(["@"]);
                                            columnRange.numberFormat = formatArray;
                                        });
                                        // Kolumna B wyrównana do lewej
                                        sheet.getRange("B3:B" + (2 + matrix_1.length)).format.horizontalAlignment = "Left";
                                        return [4 /*yield*/, context.sync()];
                                    case 3:
                                        _a.sent();
                                        range.values = matrix_1;
                                        // Filtr
                                        sheet.autoFilter.apply(sheet.getRange("A2:D2"));
                                        sheet.activate();
                                        return [4 /*yield*/, context.sync()];
                                    case 4:
                                        _a.sent();
                                        // Dodanie informacji o wersji trial
                                        return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A".concat(matrix_1.length + 3, ":D").concat(matrix_1.length + 3), isTrial, config)];
                                    case 5:
                                        // Dodanie informacji o wersji trial
                                        _a.sent();
                                        currentYear = new Date().getFullYear();
                                        currentdate = new Date();
                                        formattedDate = currentdate.toLocaleDateString("pl-PL", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit"
                                        });
                                        sheet.getRange("A".concat(matrix_1.length + 4, ":D").concat(matrix_1.length + 4)).format.fill.color = "#688BBB";
                                        sheet.getRange("A".concat(matrix_1.length + 4, ":D").concat(matrix_1.length + 4)).format.font.color = "#FFFFFF";
                                        sheet.getRange("".concat(matrix_1.length + 4, ":").concat(matrix_1.length + 4)).format.rowHeight = 15;
                                        sheet.getRange("A".concat(matrix_1.length + 4)).format.horizontalAlignment = "Left";
                                        sheet.getRange("A".concat(matrix_1.length + 4)).format.verticalAlignment = "Center";
                                        sheet.getRange("A".concat(matrix_1.length + 4)).format.font.size = 10;
                                        sheet.getRange("A".concat(matrix_1.length + 4)).values = [["Dane pobrane: ".concat(formattedDate, " | Copyright \u00A9 ").concat(currentYear, " CARBOmath")]];
                                        return [4 /*yield*/, context.sync()];
                                    case 6:
                                        _a.sent();
                                        sheet.getRange("A3").select();
                                        sheet.activate();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if (config === null || config === void 0 ? void 0 : config.appInsights) {
                        config.appInsights.trackException({ exception: error_1 });
                    }
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=dictionaries_wastecode.js.map